import SpriteSymbol from "../../../../../doctor/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../doctor/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "IconUser",
  "use": "IconUser-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"IconUser\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M0 12C0 5.37258 5.37258 0 12 0c6.6274 0 12 5.37258 12 12 0 6.6274-5.3726 12-12 12-6.62742 0-12-5.3726-12-12z\" fill=\"#858585\" /><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M16 8c0 2.21-1.79 4-4 4-2.21002 0-4.00002-1.79-4.00002-4S9.78998 4 12 4c2.21 0 4 1.79 4 4zM4 18c0-2.66 5.33-4 8-4s8 1.34 8 4v2H4v-2z\" fill=\"#fff\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol